import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  compose,
  formatNumbers,
  newFormatPrice,
  RewardTypes,
} from '../../services/utilityFunctions';
import translate from '../translate';
import CurrencyProp from '../../sections/profile/propTypes/currencyProp';
import ConfigsContext from '../../contextProviders/ConfigsContext';
import WalletIcon from '../../sections/commissions/components/wallet-picker/icons/WalletIcon';

const getCardInfo = (t, item, recurrence, organization) => {
  const { _id, value: valueItem, currency } = item;
  const { walletConfiguration } =
    organization?.services?.wallet_advanced?.config || {};

  let image = '';
  let label = '';
  let value = valueItem;
  let isCustom = null;
  let style = {};
  switch (_id) {
    case RewardTypes.COMMISSION:
      image = '/images/rewards/totalCommissions.svg';
      value = newFormatPrice(valueItem, true, currency.code);
      switch (recurrence) {
        case 'weekly':
          label = t('dashboard.rewards.commissions_this_week');
          break;
        case 'monthly':
          label = t('dashboard.rewards.commissions_this_month');
          break;
        case 'quarterly':
          label = t('dashboard.rewards.commissions_this_quarter');
          break;
        default:
          label = t('rewards_totalOfCommissions');
          break;
      }
      break;
    case RewardTypes.COINS:
      style = walletConfiguration?.coins?.icon?.url
        ? { borderRadius: '50%' }
        : {};
      image =
        walletConfiguration?.coins?.icon?.url || '/images/rewards/coins.svg';
      label = t('rewards_coins');
      value = formatNumbers(valueItem, false, false);
      break;
    case RewardTypes.CHARITY_COINS:
      image = '/images/rewards/charityCoins.svg';
      label = t('rewards_charityCoins');
      value = formatNumbers(valueItem, false, false);
      break;
    case RewardTypes.COUPONS:
      image = '/images/rewards/coupon.svg';
      label = t('rewards_coupon');
      value = formatNumbers(valueItem, false, false);
      break;
    case RewardTypes.VOUCHERS:
      image = '/images/rewards/voucher.svg';
      label = t('rewards_voucher');
      value = formatNumbers(valueItem, false, false);
      break;
    case RewardTypes.WALLET_BALANCE:
      style = walletConfiguration?.fiat?.icon?.url
        ? { borderRadius: '50%' }
        : {};
      image =
        walletConfiguration?.fiat?.icon?.url || '/images/rewards/voucher.svg';
      label = t('dashboard.rewards.wallet_balance');
      value = newFormatPrice(valueItem, true, currency.code);
      isCustom = !walletConfiguration?.fiat?.icon?.url ? (
        <div className="wallet-dashboard-container">
          <WalletIcon />
        </div>
      ) : null;
      break;
    default:
      break;
  }
  return { image, label, value, isCustom, style };
};

function RewardCardItem({ t, item }) {
  const { organization } = useContext(ConfigsContext);
  const { recurrence } = organization.directSelling || {};

  const { image, label, value, isCustom, style } = getCardInfo(
    t,
    item,
    recurrence,
    organization,
  );
  return (
    <div className="rewards-dashboard-container">
      <div className="reward-item">
        <div className="image-container">
          {isCustom || <img style={style} src={image} alt="reward" />}
        </div>
        <div className="content-container">
          <div className="label">{label}</div>
          <div className="value no-wrap-value">{value}</div>
        </div>
      </div>
    </div>
  );
}

RewardCardItem.propTypes = {
  t: PropTypes.func.isRequired,
  item: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.shape(CurrencyProp.propType),
    ]).isRequired,
  }).isRequired,
};

export default compose(translate)(RewardCardItem);
